import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-studies',
  templateUrl: './case-studies.component.html',
  styleUrls: ['./case-studies.component.scss']
})
export class CaseStudiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  //   $('.ourProjectsCardsSlider').slick({
  //     dots : true,
  //     infinite: true,
  //     slidesToShow: 3,
  //     slidesToScroll: 1,
  //     responsive: [
  //         {
  //           breakpoint: 1200,
  //           settings: {
  //             slidesToShow: 3,
  //             slidesToScroll: 1
  //           }
  //         },
  //         {
  //           breakpoint: 900,
  //           settings: {
  //             slidesToShow: 2,
  //             slidesToScroll: 1
  //           }
  //         },
  //         {
  //             breakpoint: 700,
  //             settings: {
  //               slidesToShow: 1,
  //               slidesToScroll: 1
  //             }
  //         }
  //     ]
  // });
  }
  
}
